(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-details"]) return;
  try {
    
  if (!customElements.get('pdp-info-tabs')) {
    customElements.define('pdp-info-tabs', class extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(min-width: 769px)');
        this.tabs = Array.from(this.querySelectorAll('.pdp-acc__tab'));
        this.items = Array.from(this.querySelectorAll(':scope > .pdp-acc__item'));
        this.tabs.forEach((t) => t.addEventListener('click', () => this.show(t.dataset.panel)));
        this.addEventListener('keydown', (e) => this.onKey(e));
        this.items.forEach((d) => d.addEventListener('toggle', () => { if (d.open && this.mq.matches) this.show(d.dataset.panel); }));
        this.mq.addEventListener('change', () => this.sync());
        this.moveReviews();
        this.sync();
        document.addEventListener('click', (e) => {
          if (e.target.closest('.jdgm-prev-badge, .jdgm-widget.jdgm-preview-badge, a[href="#judgeme_product_reviews"]')) this.show('reviews', true);
        }, true);
        if (location.hash === '#judgeme_product_reviews') this.show('reviews', true);
      }
      current() {
        const open = this.items.find((d) => d.open);
        return open ? open.dataset.panel : this.items[0] && this.items[0].dataset.panel;
      }
      sync() {
        if (this.mq.matches) this.show(this.current());
      }
      show(id, scroll) {
        const target = this.items.find((d) => d.dataset.panel === id);
        if (!target) return;
        if (this.mq.matches) {
          this.items.forEach((d) => { if (d !== target && d.open) d.open = false; });
          this.tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.panel === id ? 'true' : 'false'));
          this.tabs.forEach((t) => { t.tabIndex = t.dataset.panel === id ? 0 : -1; });
        }
        if (!target.open) target.open = true;
        if (scroll) this.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      onKey(e) {
        const i = this.tabs.indexOf(document.activeElement);
        if (i < 0 || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
        e.preventDefault();
        const next = this.tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length];
        next.focus();
        this.show(next.dataset.panel);
      }
      moveReviews() {
        const slot = this.querySelector('.pdp-acc__reviews-slot');
        const widget = document.querySelector('#judgeme_product_reviews, .jdgm-review-widget');
        if (!slot || !widget || slot.contains(widget)) return;
        const section = widget.closest('.shopify-section') || widget;
        if (section.contains(this)) return;
        slot.appendChild(section);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
